import { toast } from 'react-hot-toast';

// 存储通知设置的状态
let notificationSettings = {
  browser: true,
  updates: false
};

// 请求通知权限
const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    // console.log('浏览器不支持桌面通知');
    return false;
  }
  
  if (Notification.permission === 'granted') {
    return true;
  }
  
  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  
  return false;
};

// 显示浏览器通知
const showBrowserNotification = async (title, options = {}) => {
  if (!notificationSettings.browser) return null; // 如果用户禁用了浏览器通知，直接返回
  
  const hasPermission = await requestNotificationPermission();
  if (!hasPermission) return null;
  
  const notification = new Notification(title, {
    icon: '/logo.png',
    badge: '/badge.png',
    ...options,
  });
  
  notification.onclick = function() {
    window.focus();
    if (options.onClick) options.onClick();
    this.close();
  };
  
  return notification;
};

// 显示产品更新通知 (不直接使用JSX)
const showUpdateNotification = (update) => {
  if (!notificationSettings.updates) return; // 如果用户禁用了更新通知，直接返回
  
  // 使用 toast 通知，避免直接在服务中使用 JSX
  toast.custom(
    // 传入一个函数，由调用者环境提供 JSX 支持
    (t) => createUpdateToast(t, update),
    { duration: 8000 }
  );
};

// 初始化通知服务
const initNotificationService = async () => {
  try {
    // 尝试从localStorage加载设置
    const savedSettings = localStorage.getItem('notification-settings');
    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);
        notificationSettings = {
          ...notificationSettings,
          ...parsedSettings
        };
      } catch (e) {
        // console.error('解析通知设置失败:', e);
      }
    }
    
    // 如果启用了浏览器通知，请求权限
    if (notificationSettings.browser) {
      await requestNotificationPermission();
    }
    
    // console.log('通知服务初始化完成:', notificationSettings);
  } catch (error) {
    // console.error('初始化通知服务失败:', error);
  }
};

// 更新通知设置
const updateNotificationSettings = (settings) => {
  notificationSettings = {
    ...notificationSettings,
    ...settings
  };
  
  // 保存到localStorage
  try {
    localStorage.setItem('notification-settings', JSON.stringify(notificationSettings));
  } catch (e) {
    // console.error('保存通知设置失败:', e);
  }
};

// 暴露给调用者的服务
export const NotificationService = {
  init: initNotificationService,
  updateSettings: updateNotificationSettings,
  showBrowserNotification,
  showUpdateNotification,
  getSettings: () => ({ ...notificationSettings })
};

export default NotificationService;
